class TableReferenceKeyDto {
    Key: string;
    Name: string;

    constructor(key: string, name: string) {
        this.Key = key;
        this.Name = name;
    }
}

export default TableReferenceKeyDto;
